import { render, staticRenderFns } from "./declaracao.vue?vue&type=template&id=7f44de19&scoped=true&"
import script from "./declaracao.vue?vue&type=script&lang=js&"
export * from "./declaracao.vue?vue&type=script&lang=js&"
import style0 from "./declaracao.vue?vue&type=style&index=0&id=7f44de19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f44de19",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
